module.exports = __webpack_public_path__ + "static/img/RSFUPS108R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSFUPS108R_1.png
// module id = W5av
// module chunks = 0